import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { redirectToPageAction, userLoginAction } from "./actions/userActions";
import RegistrationScreen from "./screens/education/RegistrationScreen";
import useWindowResize from "./utils/WindowResize";
import ScrollToTop from "./ScrollToTop";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import ProtectedRoute from "./screens/education/reusables/ProtectedRoute";
import UploadSolution from "./screens/education/Dashboard/UploadSolution";
import DashboardCertificates from "./screens/education/Dashboard/DashboardCertificates";
import DashboardCourses from "./screens/education/Dashboard/DashboardCourses";
import Support from "./screens/education/Dashboard/Support";
import AdminProtectedRoute from "./screens/education/reusables/AdminProtectedRoute";
import WebinarEventsMobile from "./screens/education/WebinarEvents/WebinarEventsMobile";
import WebinarEvents from "./screens/education/WebinarEvents/WebinarEvents";
import MobileAppPage from "./screens/education/mobile-app-page/mobile-app-page";
import PrivacyPolicy from "./screens/policies/PrivacyPolicy";
import {
  cancellation_refund_details,
  privacy_policy_details,
  terms_use_details,
} from "./screens/policies/policy_details";
import ContactUs from "./screens/policies/ContactUs";
import Workshop from "./screens/education/Workshops/Workshop";
import WorkshopDetails from "./screens/education/Workshops/WorkshopDetails";
import DashboardWorkshop from "./screens/education/Workshops/DashboardWorkshop";
import LoginScreen from "./screens/education/LoginScreen";
import GrabCertificate from "./screens/education/Certificate/GrabCertificate";
import MyTechProfile from "./screens/education/TechProfile/MyTechProfile";
import EditMyTechProfile from "./screens/education/TechProfile/EditMyTechProfile";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import EditTechProfileForMobile from "./screens/education/TechProfile/EditTechProfileForMobile";
import { TechPortfolioLandingPage } from "./screens/education/TechProfile/TechPortfolioLandingPage";
import CertificateLandingComponent from "./screens/education/Certificate/CertificateLanding";
import QuizSelection from "./screens/education/Certificate/QuizSelection";
import QuizResult from "./screens/education/Certificate/QuizResult";
import ViewBadgesPublicComponent from "./screens/education/Certificate/ViewBadgePublicComponent";
import CertificateEachSelectionComponent from "./screens/education/Certificate/CertificateEachSelectionComponent";
import CertificateDetails from "./screens/education/Certificate/CertificateDetails";
import MainQuizStartComponent from "./screens/education/Certificate/MainQuizStartComponent";
import AdminDashboard from "./screens/education/Admin-Panels/AdminDashboard";
import PortfolioPaymentPage from "./screens/education/TechProfile/PortfolioPaymentPage";
import PaymentSuccessPage from "./screens/education/TechProfile/PaymentSuccessPage";

function App() {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(
    localStorage.getItem("acetechies_logged_in_user"), // Convert to boolean
  );
  const [movetoLogin, setMoveToLogin] = useState(false);
  const { redirectUrl } = useSelector((state) => state.redirectUrlStore);
  const isSmallScreen = useWindowResize();
  const { userInfo } = useSelector((state) => state.userLogin);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isUserLoggedIn) dispatch(userLoginAction());
  }, [dispatch, isUserLoggedIn]);

  useEffect(() => {
    if (!userInfo) {
      setMoveToLogin(false);
      setIsUserLoggedIn(null);
      return;
    }

    setMoveToLogin(true);

    const redirectPath = redirectUrl?.url;

    if (
      redirectPath &&
      redirectPath.includes("/techprofile/edit/undefined") &&
      userInfo?._id
    ) {
      dispatch(
        redirectToPageAction("EDIT_TECH_PROFILE_PAGE", {
          url: `/techprofile/edit/${userInfo._id}`,
        }),
      );
    }
  }, [userInfo, redirectUrl, dispatch]);

  // Default redirect URL if none is specified
  const defaultRedirect = redirectUrl?.url || "/";

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/payment/success">
            <PaymentSuccessPage />
          </Route>
          <Route path="/portfolio/:username">
            <MyTechProfile />
          </Route>
          <Route path="/profile/preview/:id">
            {/* <ProtectedRoute component={MyTechProfile} /> */}
            <MyTechProfile />
          </Route>
          <Route path="/certificate/grab/:id">
            <ProtectedRoute component={GrabCertificate} />
          </Route>
          <Route path="/techprofile/edit/:id">
            {isMobile ? <EditTechProfileForMobile /> : <EditMyTechProfile />}
            {/* <ProtectedRoute
              component={
                isMobile ? EditTechProfileForMobile : EditMyTechProfile
              }
            /> */}
          </Route>
          <Route path="/techprofile/portfolio-activation/:id">
            <ProtectedRoute component={PortfolioPaymentPage} />
          </Route>
          <Route path="/techprofile">
            <TechPortfolioLandingPage />
          </Route>
          {/* <Route path="/certificates/:id">
            <CertificateDetails />
          </Route> */}
          <Route path="/workshop/details/:id">
            <WorkshopDetails />
          </Route>
          <Route path="/workshop">
            <Workshop />
          </Route>
          <Route path="/contact">
            <ContactUs />
          </Route>
          <Route path="/cancellation-refund">
            <PrivacyPolicy policyData={cancellation_refund_details} />
          </Route>
          <Route path="/terms">
            <PrivacyPolicy policyData={terms_use_details} />
          </Route>
          <Route path="/privacy">
            <PrivacyPolicy policyData={privacy_policy_details} />
          </Route>
          <Route path="/dashboard/superadminpanel">
            <AdminProtectedRoute component={AdminDashboard} />
          </Route>
          {isSmallScreen || isMobile ? (
            <Route path="/events">
              <WebinarEventsMobile />
            </Route>
          ) : (
            <Route path="/events">
              <WebinarEvents />
            </Route>
          )}
          <Route path="/dashboard/support">
            <ProtectedRoute component={Support} />
          </Route>
          <Route path="/dashboard/courses">
            <ProtectedRoute component={DashboardCourses} />
          </Route>
          <Route path="/dashboard/certificates">
            <ProtectedRoute component={DashboardCertificates} />
          </Route>
          <Route path="/dashboard/uploadsolution">
            <ProtectedRoute component={UploadSolution} />
          </Route>
          <Route path="/dashboard">
            <ProtectedRoute component={DashboardWorkshop} />
          </Route>
          <Route path="/badges/public/:id">
            <ViewBadgesPublicComponent />
          </Route>
          <Route path="/certificates/details/:id">
            <CertificateDetails />
          </Route>
          <Route path="/certificates/list/:name">
            <CertificateEachSelectionComponent />
          </Route>
          <Route path="/certificates/quiz-result/:id">
            <QuizResult />
          </Route>
          <Route path="/certificates/quiz-active">
            <MainQuizStartComponent />
          </Route>
          <Route path="/certificates/start-quiz">
            <QuizSelection />
          </Route>
          <Route path="/certificates">
            <CertificateLandingComponent />
          </Route>

          {/* Modified signup route */}
          <Route path="/signup">
            {isUserLoggedIn || movetoLogin ? (
              <Redirect to={defaultRedirect} />
            ) : (
              <RegistrationScreen />
            )}
          </Route>

          <Route path="/login">
            {isUserLoggedIn || movetoLogin ? (
              <Redirect to={defaultRedirect} />
            ) : (
              <LoginScreen />
            )}
          </Route>
          <Route path="/mobile-app-page">
            <MobileAppPage />
          </Route>
          <Route path="/">
            <CertificateLandingComponent />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
